<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="128"
      is-full-screen
    />
    <v-snackbar v-model="showSnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-start>
              <v-flex  pa-4>
                <v-card style="line-height: 16px">
                  <v-layout wrap pb-3
                  
                  
                  >
                    
                    <v-flex md12>
                      <v-layout wrap justify-center px-2>
                        <v-flex text-center xs12 pt-4>
                         
                          <v-card color="yellow" elevation="0">
                            <v-layout wrap>
                              <v-flex xs12 pa-3>
                                <span
                                  style="
                                    font-size: 18px;
                                    color: #000000;
                                    font-weight: bold;
                                  "
                                >
                                  {{ PromoDetails.promoCode }}
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-card>
                        
                        </v-flex>
                       
                        <v-flex text-left xs12 pt-3 pl-2 pb-3>
                          <span  style="
                                font-size: 13px;
                                color: #000000;
                                border-bottom: 2px soild black;
                              "
                            > <b> Offer validity </b></span
                          >
                          <br />
                          <span
                            class="showLine"
                            style="font-size: 13px; color: #000000"
                          >
                            <span
                             
                              v-if="PromoDetails.vaidFromDate && PromoDetails.validToDate"
                            >
                              {{ formatDate(PromoDetails.vaidFromDate) }}
                              <!-- {{ formatTime(item.startingTime) }} -->
                              to
                              {{ formatDate(PromoDetails.validToDate) }}
                              <!-- {{ formatTime(item.endingTime) }} -->
                            </span>
                          </span>
                        </v-flex>
                        <template v-if="PromoDetails.description">
                          <v-flex xs12 text-left px-2>
                            <span
                              style="
                                font-size: 13px;
                                color: #000000;
                                border-bottom: 2px soild black;
                              "
                            >
                              <b>Description</b>
                            </span>
                          </v-flex>
                          <v-flex xs12 text-left px-2>
                            <span style="font-size: 13px; color: #000000">
                              {{ PromoDetails.description }}
                            </span>
                          </v-flex>
                          <v-flex xs12 text-left px-2 py-2>
                            <v-divider></v-divider>
                          </v-flex>
                        </template>
                        <v-flex xs6 text-left px-2 pt-1>
                          <span
                            style="
                              font-size: 13px;
                              color: #000000;
                              border-bottom: 2px soild black;
                            "
                          >
                            <b>Discount</b>
                          </span>
                        </v-flex>
                        <v-flex xs6 text-left px-2>
                          <span style="font-size: 13px; color: #000000">
                            <b> {{ PromoDetails.discount }} % </b>
                          </span>
                        </v-flex>
                        <v-flex xs6 text-left px-2 pt-1>
                          <span
                            style="
                              font-size: 13px;
                              color: #000000;
                              border-bottom: 2px soild black;
                            "
                          >
                            <b>is FirstOrder</b>
                          </span>
                        </v-flex>
                        <v-flex xs6 text-left px-2>
                          <!-- <span style="font-size: 13px; color: #000000">
                            {{ item.isForFirstOrder }}
                          </span> -->
                          <v-icon
                            x-small
                            color="green"
                            v-if="PromoDetails.isForFirstOrder == true"
                            >mdi-check-circle</v-icon
                          >
                          <v-icon x-small color="red" v-else
                            >mdi-close-circle</v-icon
                          >
                        </v-flex>
                        <v-flex xs6 text-left px-2 pt-1>
                          <span
                            style="
                              font-size: 13px;
                              color: #000000;
                              border-bottom: 2px soild black;
                            "
                          >
                            <b>Free Delivery</b>
                          </span>
                        </v-flex>
                        <v-flex xs6 text-left px-2>
                        

                          <v-icon
                            x-small
                            color="green"
                            v-if="PromoDetails.isFreeDelivery == true"
                            >mdi-check-circle</v-icon
                          >
                          <v-icon x-small color="red" v-else
                            >mdi-close-circle</v-icon
                          >
                        </v-flex>
                        <v-flex xs6 text-left px-2 pt-1>
                          <span
                            style="
                              font-size: 13px;
                              color: #000000;
                              border-bottom: 2px soild black;
                            "
                          >
                            <b>Free Packing Charge</b>
                          </span>
                        </v-flex>
                        <v-flex xs6 text-left px-2>
                          <!-- <span style="font-size: 13px; color: #000000">
                            {{ item.isFreePackingCharge }}
                          </span> -->
                          <v-icon
                            x-small
                            color="green"
                            v-if="PromoDetails.isFreePackingCharge == true"
                            >mdi-check-circle</v-icon
                          >
                          <v-icon x-small color="red" v-else
                            >mdi-close-circle</v-icon
                          >
                        </v-flex>
                        <v-flex xs6 text-left px-2 pt-1>
                          <span
                            style="
                              font-size: 13px;
                              color: #000000;
                              border-bottom: 2px soild black;
                            "
                          >
                            <b>Maximum KM</b>
                          </span>
                        </v-flex>
                        <v-flex xs6 text-left px-2>
                          <span style="font-size: 13px; color: #000000">
                            {{ PromoDetails.maxKm }}
                          </span>
                        </v-flex>

                      
                       
                       
                      
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
  </div>
</template>
<script>
import axios from 'axios';
export default {
  data() {
    return {
      appLoading: false,
      showSnackbar: false,
      PromoDetails:[]
    };
  },
  mounted() {
    this.getData();
  },
  methods: {


   formatDate(item) {
      var dt = new Date(item);
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(4, 10) + " " + year;
      return strTime;
    },



    getData() {
      this.appLoading = true;

      axios({
        url: "/promocode/details",
        method: "POST",
       
        headers: {
          token: localStorage.getItem("token"),
        },
        data:{
            id:this.$route.query.id,
        }
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            console.log(response.data.status);
            this.PromoDetails = response.data.promocode;
          } else {
            this.msg = response.data.msg;
            this.showSnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>